<template>
    <NuxtImg provider="kontentAiProvider" :alt="altText" :src="imageUrl" :densities="'1'"></NuxtImg>
</template>
<script lang="ts" setup>
const props = defineProps({
    value: {
        type: Object,
        required: true
    }
});

//@ts-ignore
const imageUrl = props.value.asset.url
//@ts-ignore
const altText = props.value.asset.alt
</script>